import { Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/ui/button';
import { cn } from '~/utils/cn';

interface Props {
  isDownloading: boolean;
  onClick: () => void;
  className?: string | undefined;
}

/**
 * CSV export button that signals an in-flight download by animating its own
 * icon and swapping its label, rather than the generic `Button` spinner —
 * `isDownloading` is fully controlled by the caller.
 */
export function CsvDownloadButton({ isDownloading, onClick, className }: Props) {
  const { t } = useTranslation('common');

  return (
    <Button
      variant="outline"
      onClick={onClick}
      disabled={isDownloading}
      className={cn(
        isDownloading ? 'cursor-not-allowed gap-2' : 'cursor-pointer gap-2',
        'rounded-lg',
        className,
      )}
    >
      <Download className={cn('h-4 w-4', isDownloading && 'animate-bounce')} aria-hidden="true" />
      {isDownloading
        ? t('csvDownloadButton.downloading', 'Starting Download')
        : t('csvDownloadButton.idle', 'CSV')}
    </Button>
  );
}
